const initialState = {
  bookmarks: null,
  isLoading: false,
  hasLoadingError: false,
  errorMessage: '',
};

export default initialState;
